/* eslint-disable indent , no-nested-ternary */
const i18n = (...params) => window.Messages(...params);

export const template = ({ store, productInfo = {} }, storeIndex) => {
  // Template params
  const quantity = productInfo.quantity || 0;
  const slice = store.open.current_slice;

  let stockInformation = '';
    if (quantity > 1) {
      stockInformation = `
        <span class="store-selection__stock">
          <strong>${i18n('storeselection.stock.instock')}</strong>
          <span class="store-selection__availability">- ${i18n('storeselection.stock.quantity.plural', quantity)}</span>
        </span>`;
    } else if (quantity === 1) {
      stockInformation = `
        <span class="store-selection__stock">
          <strong>${i18n('storeselection.stock.instock')}</strong>
          <span class="store-selection__availability">- ${i18n('storeselection.stock.quantity.singular')}</span>
        </span>`;
    } else {
      stockInformation = `
        <span class="store-selection__stock store-selection__stock--no-stock">
          <strong>${i18n('storeselection.stock.notinstock')}</strong>
        </span>`;
    }

  return `
  <li class="store-selection__store js-store-result">
    <h4>${storeIndex + 1} - ${store.name}</h4>
    ${stockInformation}
    ${
      store.open.open_now /* OPEN / CLOSE + current slice */
        ? `<span class="store-selection__hours">
        ${i18n('storeselection.storeOpeningHours', slice.start, slice.end)}
        </span>`
        : `<span class="store-selection__hours store-selection__hours--closed">
          ${i18n('storeselection.storeIsClosed')}
        </span>`
    }
  </li>
  `;
};



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/templates/template-no-click-n-collect.js